<template>
<b-card header="Add manager form">

  <b-form id="initmanager-form">
    <!-- <b-form-group>
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>Phonenumber</b-input-group-text>
        </b-input-group-prepend>
        <b-form-input type="text" v-model="formData.phone" placeholder="Phone"></b-form-input>
        <b-input-group-append>
          <b-input-group-text><i class="fa fa-phone"></i></b-input-group-text>
        </b-input-group-append>
      </b-input-group>
    </b-form-group> -->

    <b-form-group>
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>Email or Phone</b-input-group-text>
        </b-input-group-prepend>
        <b-form-input type="text" v-model="formData.userName" placeholder="Email or Phone"></b-form-input>
        <b-input-group-append>
          <b-input-group-text><i class="icon-user"></i></b-input-group-text>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-form-group>
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>Start</b-input-group-text>
        </b-input-group-prepend>
        <b-form-input type="date" id="startDate" v-model="formData.startDate" placeholder="StartDate"></b-form-input>
        <b-form-input type="time" id="startTime" v-model="formData.startTime"></b-form-input>
        <b-input-group-append>
          <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-form-group>
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>End</b-input-group-text>
        </b-input-group-prepend>
        <b-form-input type="date" id="endDate" v-model="formData.endDate" placeholder="EndDate"></b-form-input>
        <b-form-input type="time" id="endTime" v-model="formData.endTime"></b-form-input>
        <b-input-group-append>
          <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-form-group>
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>Notes</b-input-group-text>
        </b-input-group-prepend>
        <b-form-textarea :rows="3" :max-rows="6" id="description" v-model="formData.notes" placeholder="Notes" :value="Notes"></b-form-textarea>
        <b-input-group-append>
          <b-input-group-text><i class="fa fa-sticky-note-o"></i></b-input-group-text>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <div class="form-group form-actions">
      <b-button @click="submitDataManager($event.target)" type="button" size="sm" variant="primary">Save</b-button>
    </div>
  </b-form>
</b-card>
</template>

<script>

let qs = require('qs')
const constants = require('./shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/lockManagers/add'
const API_LIST = BASE + '/api/lockManagers/list'

function postdata (url, data) {
  let partsStartDate = data.startDate.split('-')
  let partsEndDate = data.endDate.split('-')
  var partEndTime = data.endTime.split(':')
  var partStartTime = data.startTime.split(':')
  data.endDate = new Date(partsEndDate[0], partsEndDate[1] - 1, partsEndDate[2], partStartTime[0], partStartTime[1]).getTime()
  data.startDate = new Date(partsStartDate[0], partsStartDate[1] - 1, partsStartDate[2], partEndTime[0], partEndTime[1]).getTime()

  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    method: 'POST'
  })
    .then(res => res.json())
}

function postAPI (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function getData () {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token')
  }
  let res = await postAPI(API_LIST, parameters)
  return res.lockManagers
}

export default {
  name: 'manager-add-form',
  data () {
    return {
      formData: {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        lockId: '',
        lockGroupId: '',
        userName: '',
        addDate: '',
        endDate: '',
        startDate: '',
        startTime: '',
        endTime: '',
        notes: ''
      }
    }
  },
  mounted () {
    this.$data.formData.addDate = constants.getToday()
    this.$data.formData.startDate = constants.getToday()
    this.$data.formData.endDate = constants.getEndDate()
    this.$data.formData.startTime = constants.getTimeNow()
    this.$data.formData.endTime = constants.getTimeNow()
  },
  methods: {
    submitDataManager (button) {
      postdata(API, this.formData)
        .then(data => {
          getData().then(dataList => {
            this.$root.$emit('managers', dataList)
            this.$root.$emit('modalShow', false)
            this.formData.userName = ''
            this.formData.addDate = constants.getToday()
            this.formData.startDate = constants.getToday()
            this.formData.endDate = constants.getEndDate()
            this.formData.startTime = constants.getTimeNow()
            this.formData.endTime = constants.getTimeNow()
            this.formData.notes = ''
          })
          console.log(data)
        })
        .catch(error => {
          console.error(error)
        })
    },
    onReset (evt) {
      evt.preventDefault()
      this.formData.lockId = ''
      this.formData.managerId = ''
      this.formData.addDate = constants.getToday()
      this.formData.startDate = constants.getToday()
      this.formData.locationId = ''
      this.formData.endDate = constants.getEndDate()
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          alert('From Submitted!')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/ManagerAddForm.vue